import { Skeleton } from '@/components/ui/skeleton'

interface SidebarSkeletonProps {
  loading: boolean
  rows: number
  rowHeight: number
}

export const SidebarSkeleton: React.FC<SidebarSkeletonProps> = ({ loading, rows, rowHeight }) => {
  if (!loading) return null

  return (
    <>
      {Array.from({ length: rows }).map((_, index) => (
        <div
          key={index}
          className="flex items-center justify-center px-3 group-data-[collapsible=icon]:px-0"
          style={{ height: rowHeight }}
        >
          <Skeleton className="h-4 w-full bg-white/10 group-data-[collapsible=icon]:size-8 group-data-[collapsible=icon]:rounded-sm" />
        </div>
      ))}
    </>
  )
}
